import styled from 'styled-components';

export const SheetContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs};
`;

export const CloseButton = styled.button`
  align-self: flex-end;
  background: none;
  border: none;
  font-size: ${({ theme }) => theme.typography.fontSize.md};
  color: ${({ theme }) => theme.colors.text.secondary};
  cursor: pointer;
  padding: ${({ theme }) => theme.spacing.xs};
`;

export const TextArea = styled.textarea`
  min-height: 140px;
  padding: ${({ theme }) => theme.spacing.ms};
  border: 1px solid ${({ theme }) => theme.colors.border.input};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  font-size: ${({ theme }) => theme.typography.fontSize.lg};
  font-family: inherit;
  line-height: 1.6;
  resize: none;
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text.primary};

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary};
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.text.muted};
  }
`;

export const CheckboxRow = styled.label`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
  cursor: pointer;
  user-select: none;
`;

export const Checkbox = styled.input`
  width: 18px;
  height: 18px;
  accent-color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;
`;

export const CheckboxLabel = styled.span`
  font-size: ${({ theme }) => theme.typography.fontSize.md};
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const ButtonRow = styled.div`
  display: flex;
  margin-top: ${({ theme }) => theme.spacing.xs};
`;

export const VoiceButton = styled.button<{ $isRecording?: boolean }>`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.sm};
  padding: ${({ theme }) => theme.spacing.ms};
  min-height: 44px;
  border: 2px solid ${({ theme }) => theme.colors.primary};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  background-color: ${({ $isRecording, theme }) => $isRecording ? theme.colors.backgroundTableGood : 'white'};
  color: ${({ theme }) => theme.colors.primary};
  font-size: ${({ theme }) => theme.typography.fontSize.md};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.2s ease;

  & > svg {
    flex-shrink: 0;
  }
`;

export const SendButton = styled.button<{ $hidden?: boolean }>`
  flex: ${({ $hidden }) => ($hidden ? 0 : 2)};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.sm};
  margin-left: ${({ $hidden, theme }) => ($hidden ? 0 : theme.spacing.ms)};
  padding: ${({ $hidden, theme }) => ($hidden ? 0 : theme.spacing.ms)};
  min-width: ${({ $hidden }) => ($hidden ? 0 : 'auto')};
  max-width: ${({ $hidden }) => ($hidden ? '0px' : '100%')};
  opacity: ${({ $hidden }) => ($hidden ? 0 : 1)};
  overflow: hidden;
  white-space: nowrap;
  min-height: ${({ $hidden }) => ($hidden ? 0 : '44px')};
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.md};
  background-color: ${({ theme }) => theme.colors.primary};
  color: white;
  font-size: ${({ theme }) => theme.typography.fontSize.md};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  cursor: pointer;
  transition: all 0.2s ease;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
